export const STREAK_BUTTON_LABEL_TOMORROW = '明日もがんばる！';
export const STREAK_BUTTON_LABEL_CONTINUE = 'この調子で習慣にする！！';
export const STREAK_FIRST_COMPLETION_MESSAGE = 'この調子で明日も続けて、\n連続記録の炎を燃やし続けましょう！';
export const STREAK_FIRST_COMPLETION_TITLE_SUFFIX = '日目クリア！🔥';
export const STREAK_COUNT_UNIT = '日連続記録';
export const buildStreakCountdownText = (seconds) => `${seconds}秒後に続きます`;
